import {
  GenericWrapperWithIdNavigateAndBackUrl,
  GenericWrapperWithIdNavigateIsNewAndBackUrl,
  GenericWrapperWithNavigate,
  GenericWrapperWithNavigateAndBackUrl,
} from "../genericWrappers";
import NoRouteErrorPage from "../no-route-error-page";
import { Index } from "../../Consent/StartPage/index";
import Details from "../../Consent/EInvoice/Details/Details";
import Edit from "../../Consent/EInvoice/Edit/Edit";
import EInvoiceHistory from "../../Consent/EInvoice/History/History";

const consentRoutes = [
  {
    path: "Consent",
    children: [
      {
        path: "index",
        element: (
          <GenericWrapperWithNavigate key={"Consent/index"} component={Index} />
        ),
      },
      {
        path: "EInvoice",
        children: [
          {
            path: "index",
            element: (
              <GenericWrapperWithNavigate
                key={"Consent/EInvoice/index"}
                component={Details}
              />
            ),
          },
          {
            path: "edit",
            element: (
              <GenericWrapperWithIdNavigateAndBackUrl
                key={"Consent/EInvoice/edit"}
                component={Edit}
              />
            ),
          },
          {
            path: "history",
            element: (
              <GenericWrapperWithIdNavigateAndBackUrl
                key={"Consent/EInvoice/history"}
                component={EInvoiceHistory}
              />
            ),
          },
          {
            path: "*",
            element: <NoRouteErrorPage />,
          },
        ],
      },
      {
        path: "*",
        element: <NoRouteErrorPage />,
      },
    ],
  },
];

export default consentRoutes;
